import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { api, API } from "@/lib/api";
import { PageTitle, GBtn, inputCls, StatusBadge } from "./ui";
import { Search, Download } from "lucide-react";

const FILTERS = ["all", "Pending Payment", "Awaiting Questionnaire", "Questionnaire Received", "In Progress", "Delivered"];

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [status, setStatus] = useState("all");
  const [q, setQ] = useState("");
  const nav = useNavigate();

  const load = useCallback(async () => {
    const { data } = await api.get("/admin/orders", { params: { status, q } });
    setOrders(data);
  }, [status, q]);

  useEffect(() => { load(); }, [load]);

  return (
    <>
      <PageTitle title="Orders" subtitle={`${orders.length} order(s)`}
        right={<a href={`${API}/admin/orders-export`} data-testid="orders-export"><GBtn variant="ghost"><Download size={16} /> Export CSV</GBtn></a>} />

      <div className="flex flex-wrap gap-3 mb-5">
        <div className="relative flex-1 min-w-[200px]">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-white/30" size={16} />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search ref, name or email" data-testid="orders-search" className={`${inputCls} pl-9`} />
        </div>
        <select value={status} onChange={(e) => setStatus(e.target.value)} data-testid="orders-filter" className={`${inputCls} sm:w-64`}>
          {FILTERS.map((f) => <option key={f} value={f}>{f === "all" ? "All statuses" : f}</option>)}
        </select>
      </div>

      <div className="card-surface rounded-2xl overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]">
          <thead><tr className="border-b border-white/10 text-white/50 text-xs uppercase">
            <th className="text-left p-4">Ref</th><th className="text-left p-4">Product</th><th className="text-left p-4">Customer</th>
            <th className="text-left p-4">Amount</th><th className="text-left p-4">Status</th><th className="text-left p-4">Date</th>
          </tr></thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.id} onClick={() => nav(`/admin/orders/${o.id}`)} data-testid={`order-row-${o.order_ref}`}
                className="border-b border-white/5 hover:bg-white/5 cursor-pointer">
                <td className="p-4 text-[#D4AF37]">{o.order_ref}</td>
                <td className="p-4 max-w-[220px] truncate">{o.product_name}</td>
                <td className="p-4"><div>{o.customer_name || "—"}</div><div className="text-white/40 text-xs">{o.customer_email}</div></td>
                <td className="p-4">£{o.amount}</td>
                <td className="p-4"><StatusBadge status={o.status} /></td>
                <td className="p-4 text-white/40 text-xs">{o.created_at ? new Date(o.created_at).toLocaleDateString("en-GB") : ""}</td>
              </tr>
            ))}
            {orders.length === 0 && <tr><td colSpan={6} className="p-10 text-center text-white/30">No orders found.</td></tr>}
          </tbody>
        </table>
      </div>
    </>
  );
}
